module.exports = __webpack_public_path__ + "img/共面波导-规则.c0b2ed25.svg";